import { onLCP, onINP, onCLS, onFCP, onTTFB } from "web-vitals"
import { ANALYTICS_EVENT_NAMES } from "./events"

/**
 * Report Core Web Vitals (LCP, INP, CLS) plus the supporting field metrics (FCP, TTFB) to Ahoy, once each
 * settles. web-vitals fires each callback with the FINAL value at the right time (LCP/CLS/INP accumulate over
 * the page's life and report on page hide / bfcache), so this is one event per metric per page load.
 *
 * Sent to Ahoy only — that's what the admin Web Vitals dashboard reads; PostHog/GA collect their own vitals.
 * The current (sanitized) path is attached by analytics.track, so the dashboard can break down by page.
 *
 * @param {(event: string, props?: object, options?: object) => void} track - analytics.track
 */
export const initWebVitals = (track) => {
  if (typeof window === "undefined") return

  // The page's Rails controller/action (from the server-rendered window config), so the dashboard can group
  // and filter vitals by page/section — matching the dimensions on server-tracked $view events. Path is
  // added by analytics.track itself (sanitized).
  const ctx = window.LoveIrish?.analytics || {}

  const report = (metric) =>
    track(
      ANALYTICS_EVENT_NAMES.WEB_VITALS,
      {
        metric: metric.name, // "LCP" | "INP" | "CLS" | "FCP" | "TTFB"
        value: metric.value, // milliseconds (unitless for CLS)
        rating: metric.rating, // "good" | "needs-improvement" | "poor"
        metric_id: metric.id, // unique per page load, for de-duping
        navigation_type: metric.navigationType, // navigate | reload | back-forward | ...
        controller: ctx.controller,
        action: ctx.action,
      },
      { services: ["ahoy"] }
    )

  onLCP(report)
  onINP(report)
  onCLS(report)
  onFCP(report)
  onTTFB(report)
}

export default initWebVitals
